import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const LoginStep: React.FC = () => {
  const { goNext, goBack, updateSelfServiceData } = useWizard();
  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.login).then(c => {
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  const handleLogin = async () => {
    try {
      // Allow test toggle for addressingName via query
      const params = new URLSearchParams(window.location.search);
      const addressingName = params.get('addressingName')?.toLowerCase() === 'true';
      const response = await fetch(`/api/nemlogin/simulate-login${addressingName ? '?addressingName=true' : ''}`);
      const userInfo = await response.json();
      
      updateSelfServiceData('user', userInfo);
      goNext();
    } catch (error) {
      console.error('Login fejlede:', error);
    }
  };

  return (
    <StepContainer title="Log ind med MitID">
      {body ? (
        <InfoBox type="info">{body.map((p,i) => <p key={i}>{p}</p>)}</InfoBox>
      ) : (
        <p>For at fortsætte skal du logge ind med dit MitID.</p>
      )}
      <NavigationButtons
        onBack={goBack}
        onNext={handleLogin}
        nextText="Log ind med MitID"
      />
    </StepContainer>
  );
};

export default LoginStep;

